import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-sociale-et-sante',
  templateUrl: './action-sociale-et-sante.component.html',
  styleUrls: ['./action-sociale-et-sante.component.scss']
})
export class ActionSocialeEtSanteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
